import * as types from 'legacy/src/constants/types';

const initialState = {
  item: {
    value: 'current',
    label: 'Current Students',
  },
};

const activeItem = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_ACTIVE_ITEM:
      return {
        ...state,
        item: action.payload,
      };
    default:
      return state;
  }
};

export default activeItem;
